export default __webpack_public_path__ + "static/media/cancer4.110b18e4.jpg";